import { useParams } from "react-router-dom";
import { QuoteBudgetVersionCompareFeature } from "../ui/QuoteBudgetVersionCompareFeature";
import "./quoteBudgetVersionCompare.css";

/** 在后台母版之外挂载核价版本比较工具。 */
export function QuoteBudgetVersionComparePage() {
  const { budgetOrderId = "" } = useParams<{ budgetOrderId: string }>();
  return <QuoteBudgetVersionCompareFeature key={budgetOrderId} budgetOrderId={budgetOrderId} />;
}
